<div style="position:relative;overflow:hidden;">
  <div bind:this={mapElement} style="width:100%; height:300px;"></div>
  {#if drawCircle}
    <div style="position:absolute;top:50%;left:50%;">
      <div
        style="position:absolute;top:{-markerSize / 2}px;left:{-markerSize / 2}px;width:{markerSize}px;height:{markerSize}px;background-color:rgba(255,35,76, 0.3);border-radius:{markerSize / 2}px;pointer-events:none;">
        &nbsp;
      </div>
    </div>
  {/if}
</div>

<script>
  export let location,
    drawCircle = false;

  import { onMount } from "svelte";

  let mapElement;

  let map;

  let zoom = 11;
  const zoomToSize = {
    22: 2000,
    21: 2000,
    20: 2000,
    19: 2000,
    18: 1600,
    17: 800,
    16: 400,
    15: 200,
    14: 100,
    13: 50,
    12: 50,
    11: 50,
    10: 50,
    9: 50
  }
  $: markerSize = zoomToSize[zoom];
  

  onMount(() => {
    map = new window.google.maps.Map(mapElement, {
      center: { lat: location.latitude, lng: location.longitude },
      zoom: 11,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      gestureHandling: "none",


    });
    map.addListener('zoom_changed', () => {
      zoom = map.getZoom();
    });
  });
</script>
